import React, { useState, Fragment } from 'react';
import { Row, Modal, ModalHeader, ModalBody, Button, Collapse } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import Message from '../Message/Message';
import ImgLink from '../ImgLink/ImgLink';
import ImageCarousel from '../ImageCarousel/ImageCarousel';
import {
  AddImgButton,
  AddMessageButton,
  DeleteButton,
  DisabledAddLinkButton,
  DisabledAddInvokeApiButton,
  AddApiButton,
  AddInvokeApiButton,
  DisabledAddVideoButton,
  // AddProductButton,
  // AddRoomsButton
} from '../Button/AddButton';
import ResponseInformation from './ResponseInformation';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';

import { putAPI_Delete_Response } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ChildButtonsResponse from './ChildButtonsResponse';
import BotResponseButton from '../ApiButtons/BotResponseButton';
import InvokeApi from '../InvokeApi/InvokeApi';

function ImageCarouselResponse({
  reloadBotResponse,
  elem,
  /** Globle property id from redux */
  propertyId,
  child,
  SaveRecommenderQuestionCode,
  DeleteQuestion,
  QuestionId,
  locale,
  favouriteResponse,
  showFav,
  viewResponse,
  userRole,
  propertyList,
  selectedLang,
  historyUpdator,
  ishistory,
  isLogHistory,
  isButtonShow,
  isRecommender
  // isFlowButton,
  // handleRoomproduct
}) {
  const [isAddInvokeApi, setIsAddInvokeApi] = useState(false);
  const [isAddMsg, setIsAddMsg] = useState(false);
  const [isAddImage, setIsAddImage] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [isAddApiButton, setIsAddApiButton] = useState(false);
  //console.log("elem", elem)
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };

  const toggleButtonAddedd = () => {
  };
  const toggleButtonMessageAddedd = () => {
  }
  const handleDelete = code => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Response}/${code}`,
      data: {
        GroupId: getGroupID(),
        PropertyId: propertyId,
        Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
        Channel: 'WebsiteDirectLine',
        UserName: historyUpdator
      },
    })
      .then(res => {
        // console.log(res.data);
        toggle();
      })
      .finally(
        setTimeout(() => {
          if (DeleteQuestion !== undefined) {
            DeleteQuestion(QuestionId)
          }
          else {
            reloadBotResponse();
          }
        }, 1000)
      )
      .catch(err => {
        console.log(err);
      });
  };

  const generateButtonGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="2" className="mb-1">
              <div
                onClick={() => {
                  setIsAddMsg(true);
                }}
              >
                <AddMessageButton className="add-button" />
              </div>
            </Colxx>
            <Colxx xs="12" sm="2" className="mb-1">
              <DisabledAddLinkButton className="add-button" disabled={true} />
            </Colxx>
            <Colxx xs="12" sm="2" className="mb-1">
              <div
                onClick={() => {
                  setIsAddImage(true);
                }}
              >
                <AddImgButton className="add-button" />
              </div>
            </Colxx>
            {child === undefined && (<Colxx xs="12" sm="2" className="mb-1">
              <div
                onClick={() => {
                  setIsAddApiButton(true);
                }}
              >
                <AddApiButton className="add-button" />
              </div>
            </Colxx>)}
            <Colxx xs="12" sm="2" className="mb-1">
              <DisabledAddVideoButton className="add-button" disabled={true} />
            </Colxx>
            {isRecommender !== undefined &&
              <Colxx xs="12" sm="2" className="mb-1">
                <DisabledAddInvokeApiButton className="add-button" disabled={true} />
              </Colxx>
            }

            {/* {isFlowButton === true && (
              <Fragment>
                <Colxx xs="12" sm="2" className="mb-1">
                  <div
                    onClick={() => {
                      handleRoomproduct({ type: "room", visible: true });
                    }}
                  >
                    <AddRoomsButton className="add-button" />
                  </div>
                </Colxx>
                <Colxx xs="12" sm="2" className="mb-1">
                  <div
                    onClick={() => {
                      handleRoomproduct({ type: "product", visible: true });
                    }}
                  >
                    <AddProductButton className="add-button" />
                  </div>
                </Colxx>
              </Fragment>
            )} */}
            <Colxx xs="12" sm="2" className="mb-1">
              <div onClick={toggle}>
                <DeleteButton className="add-button" />
              </div>
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This response will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete(elem.query.code)}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  let idxCount = -1;

  return (
    <Row>
      <Colxx xxs="12" xs="3">
        {child === undefined && (<ResponseInformation elem={elem} favouriteResponse={favouriteResponse} reloadBotResponse={reloadBotResponse} showFav={showFav} userRole={userRole} propertyList={propertyList} selectedLang={selectedLang} historyUpdator={historyUpdator} />)}
        {isLogHistory === true &&
          <Fragment>
            Version On:<br />
            {moment(elem.updatedDate).format(
              'DD-MM-YYYY h:mm a'
            )}<br /><br />
            {elem.historyUpdator !== undefined &&
              <Fragment>
                Updated By:<br />
                {elem.historyUpdator}<br /><br />
              </Fragment>
            }
            {elem.action !== undefined &&
              <Fragment>
                Action:<br />
                <span style={{ color: `${elem.action === "Deleted" ? "red" : ""}` }}>{elem.action}</span>
              </Fragment>
            }
          </Fragment>
        }
      </Colxx>
      <Colxx xxs="12" xs={child === undefined ? "9" : isLogHistory === true ? "9" : "12"}>
        <Row>
          <Colxx md="12" className="mb-2">
            {elem.response.messages.map((msg, index) => {
              idxCount++;
              return (
                <Row key={index}>
                  <Colxx xxs="12" className="mb-2">
                    <Message
                      key={index}
                      index={index}
                      code={elem.query.code}
                      type={elem.response.type}
                      msg={msg}
                      messages={elem.response.messages}
                      example={elem.response.example}
                      urls={elem.response.details.urls}
                      captions={elem.response.details.captions}
                      numberOfMsg={elem.response.numberOfMsg}
                      reloadBotResponse={reloadBotResponse}
                      SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                      viewResponse={viewResponse}
                      selectedLang={selectedLang}
                      historyUpdator={historyUpdator}
                      isButtonShow={isButtonShow}
                    />
                  </Colxx>
                </Row>
              );
            })}
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-2">
            <ImageCarousel
              code={elem.query.code}
              urls={elem.response.details.urls}
              captions={elem.response.details.captions}
              messages={elem.response.messages}
              reloadBotResponse={reloadBotResponse}
              SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
              apiButtons={elem.apiButtons}
              viewResponse={viewResponse}
              selectedLang={selectedLang}
              historyUpdator={historyUpdator}
              isButtonShow={isButtonShow}
            />
          </Colxx>
        </Row>
        {isAddMsg ? (
          <Row>
            <Colxx md="12" className="mb-2">
              <Message
                isAdd={isAddMsg}
                code={elem.query.code}
                type={elem.response.type}
                msg={''}
                messages={elem.response.messages}
                index={idxCount + 1}
                example={elem.response.example}
                setIsAddMsgToFalse={() => setIsAddMsg(false)}
                numberOfMsg={0}
                urls={elem.response.details.urls}
                captions={elem.response.details.captions}
                reloadBotResponse={reloadBotResponse}
                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                selectedLang={selectedLang}
                historyUpdator={historyUpdator}
              />
            </Colxx>
          </Row>
        ) : null}
        {isAddInvokeApi ? (
          <Row>
            <Colxx md="12" className="mb-2">
              <InvokeApi
                isAdd={isAddInvokeApi}
                code={elem.query.code}
                type={elem.response.type}
                msg={''}
                messages={elem.response.messages}
                index={idxCount + 1}
                example={elem.response.example}
                setIsAddMsgToFalse={() => setIsAddInvokeApi(false)}
                numberOfMsg={0}
                apiCollections={elem.response.details.apiCollection}
                reloadBotResponse={reloadBotResponse}
                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                selectedLang={selectedLang}
                historyUpdator={historyUpdator}
              />
            </Colxx>
          </Row>
        ) : null}
        {isAddImage ? (
          <Row>
            <Colxx md="12" className="mb-2">
              <ImgLink
                urls={elem.response.details.urls}
                captions={elem.response.details.captions}
                isAdd={isAddImage}
                code={elem.query.code}
                messages={elem.response.messages}
                isAddImage={isAddImage}
                setIsAddImageToFalse={() => setIsAddImage(false)}
                reloadBotResponse={reloadBotResponse}
                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                selectedLang={selectedLang}
                historyUpdator={historyUpdator}
              />
            </Colxx>
          </Row>
        ) : null}
        {viewResponse !== true && isButtonShow && generateButtonGroup()}
        <Collapse isOpen={isAddApiButton}>
          <Row>
            <Colxx md="6" className="mb-2">
            </Colxx>
            <Colxx md="5" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
              <BotResponseButton
                isAdd={isAddApiButton}
                index={0}
                code={elem.query.code}
                messages={elem.response.messages}
                setIsAddImageToFalse={() => setIsAddApiButton(false)}
                reloadBotResponse={reloadBotResponse}
                type={"imagecarousel"}
                buttonText={""}
                buttonValue={""}
                urls={elem.response.details.urls}
                captions={elem.response.details.captions}
                toggleButtonAddedd={toggleButtonAddedd}
                toggleButtonMessageAddedd={toggleButtonMessageAddedd}
                selectedLang={selectedLang}
                historyUpdator={historyUpdator}
              />
            </Colxx>
            <Colxx md="1" className="mb-2">
            </Colxx>
          </Row>
        </Collapse>

        {elem.apiButtons !== undefined && elem.apiButtons.length > 0 ? (
          <Fragment>
            {elem.apiButtons.map((button, index) => {
              return (
                <ChildButtonsResponse key={index} elem={elem} button={button} index={index} reloadBotResponse={reloadBotResponse} propertyId={propertyId} type={"imagecarousel"} selectedLang={selectedLang} viewResponse={viewResponse} historyUpdator={historyUpdator} ishistory={ishistory} isButtonShow={isButtonShow} />)
            })}
          </Fragment>
        ) : null}
      </Colxx>
    </Row>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps)(ImageCarouselResponse));
